import React, { useRef, useEffect, useState, useCallback } from 'react';
import { getScrollPosition } from './scrollPosition';

function ListSentinel({ showMoreItems, itemIndex, overscrollPx }) {
  const sentinelRef = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      window.requestAnimationFrame(() => {
        if (!sentinelRef.current) {
          return;
        }
        const distanceUntilVisible = getScrollPosition(sentinelRef.current);
        if (distanceUntilVisible < overscrollPx) {
          showMoreItems(itemIndex);
        }
      });
    };
    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, [showMoreItems, itemIndex, overscrollPx]);
  return <div ref={sentinelRef} style={{ width: '100%' }} />;
}

export function useLazyList(totalLength, overscrollPx = 5000, loadIncrement = 100) {
  const [maxToDisplay, setMaxToDisplay] = useState(loadIncrement);

  const SentinelElement = useCallback(() => (
    <ListSentinel
      itemIndex={maxToDisplay}
      showMoreItems={itemIndex => {
        const minimumItemsToShow = Math.max(itemIndex + loadIncrement, maxToDisplay);
        setMaxToDisplay(Math.min(minimumItemsToShow, totalLength));
      }}
      overscrollPx={overscrollPx}
    />
  ), [maxToDisplay, setMaxToDisplay, totalLength, loadIncrement, overscrollPx]);

  const reset = useCallback(() => {
    setMaxToDisplay(loadIncrement);
  }, [setMaxToDisplay, loadIncrement]);

  return [maxToDisplay, SentinelElement, reset];
}
